import React, { Component } from 'react';
import { Alert, Button, Modal, ModalHeader, ModalFooter, ModalBody, Label } from 'reactstrap';
import { gql } from 'apollo-boost';
import { Mutation } from 'react-apollo';
import { Formik } from 'formik';
import FormikInputField from '~/components/formikInputField/formikInputField';
import SubmissionButton from '~/components/submissionButton/submissionButton';
import MeasurementTypeText from '~/components/measurementTypeText/measurementTypeText';
import { amountAdjustmentValidationSchema } from '~/validation/ingredient';

export const adjustIngredientAmountMutation = gql`
  mutation adjustIngredientAmount($id: Int!, $amount: Float!, $notes: String) {
    adjustIngredientAmount(id: $id, amount: $amount, notes: $notes) {
      id
    }
  }
`;

const AdjustIngredientAmountForm = ({ handleSubmit, onCancelClick, ingredient, errors, isSubmitting }) => (
  <form onSubmit={handleSubmit}>
    <ModalBody>
      {errors.unknown && <Alert color="danger">{errors.unknown}</Alert>}
      <div className="mb3">
        <Label>How much do you currently have on hand?</Label>
        <div className="flex">
          <FormikInputField className="flex-grow-1" name="amount" invalid={!!errors.amount} />
          <span className="ml1 align-self-center">
            <MeasurementTypeText type={ingredient.measurementType} />
          </span>
        </div>
        {errors.amount && <p className="error">{errors.amount}</p>}
      </div>
      <div className="mb3">
        <Label>Notes</Label>
        <FormikInputField type="textarea" name="notes" />
      </div>
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" onClick={onCancelClick}>
        Cancel
      </Button>{' '}
      <SubmissionButton type="submit" color="primary" isSubmitting={isSubmitting}>
        Adjust
      </SubmissionButton>
    </ModalFooter>
  </form>
);

export class AdjustIngredientAmountOnHandModal extends Component {
  state = {
    error: null
  };

  render() {
    const { isOpen, onToggle, onSuccess, ingredient, refetchQueries } = this.props;

    return (
      <Modal isOpen={isOpen} toggle={onToggle}>
        <ModalHeader toggle={onToggle}>Complete these lots</ModalHeader>
        <Mutation mutation={adjustIngredientAmountMutation}>
          {adjustIngredient => (
            <Formik
              validationSchema={amountAdjustmentValidationSchema}
              validateOnChange={false}
              validateOnBlur={false}
              onSubmit={async (values, { setErrors, setSubmitting }) => {
                try {
                  await adjustIngredient({
                    variables: {
                      ...values,
                      id: ingredient.id
                    },
                    awaitRefetchQueries: true,
                    refetchQueries: refetchQueries || ['ingredient', 'ingredientAdjustments']
                  });
                  onSuccess();
                } catch (err) {
                  setErrors({
                    unknown: 'An unknown error occured'
                  });
                  setSubmitting(false);
                }
              }}
              render={props => (
                <AdjustIngredientAmountForm
                  {...props}
                  ingredient={ingredient}
                  onCancelClick={onToggle}
                  onSuccess={onSuccess}
                />
              )}
            />
          )}
        </Mutation>
      </Modal>
    );
  }
}

export default AdjustIngredientAmountOnHandModal;



// WEBPACK FOOTER //
// ./src/containers/adjustIngredientAmountOnHandModal/adjustIngredientAmountOnHandModal.jsx